import MessagePage from "src/components/MessagePage";
import { useRouteError } from "react-router-dom";

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  return (
    <div id="error-page">
      <MessagePage 
        title="Oops!"
        message={'Perdón, un error ha ocurrido.'}
        buttonText="Ir a transacciones"
        buttonTo="/"
      />
    </div>
  );
}